import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  pointer-events: none;\n  opacity: ', ';\n'], ['\n  pointer-events: none;\n  opacity: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']);

import styled from 'styled-components';

export var Container = styled.div(_templateObject);

export var ContentsContainer = styled.div(_templateObject2, function (p) {
  return p.contentsOpacity;
});

export var SpinnerContainer = styled.div(_templateObject3);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/styled/LoadingContainer.js
// module id = 900
// module chunks = 0